window.intlTelInput = require('./thirdparty/phone-input/phone-input');
let initLoadUtils = false;

function setupPhoneFields(uniqueNameFix, target) {
  let locale = document.documentElement.getAttribute('data-locale');

  if (typeof window.intlTelInput === 'undefined') return;

  // this forces the utils script to load much earlier, reducing blocking time
  if (!initLoadUtils) {
    initLoadUtils = true;
    window.intlTelInputGlobals.loadUtils('_resources/themes/default/dist/js/thirdparty/phone-input/utils.js');
  }

  $(target || 'input.format--phone').each(function () {
    if (this.hasAttribute('data-intl-tel-input-id')) return;

    let formatUnique = this.className.match(/format--unique/);

    //this.value = '';
    let iti = window.intlTelInput(this, {
      initialCountry: locale ? locale.toLowerCase() : 'gb',
      hiddenInput: !formatUnique ? 'full' : this.name + '-full',
      preferredCountries: ['gb', 'us', 'au', 'ie', 'nz', 'ca', 'mx', 'es']
    });

    setTimeout(() => {
      !iti.hiddenInput.value && (iti.hiddenInput.value = (iti.getNumber() || this.value));
    }, 100)

    let formatTimeout;

    $(this).on('keydown keyup keypress change', function (e) {
      clearTimeout(formatTimeout);

      formatTimeout = setTimeout(() => {
        iti.hiddenInput.value = iti.getNumber();
      }, 10)
    })
  })
}

// init phone input only when in view
if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio < 1) return;

      setupPhoneFields(false, entry.target);
      observer.unobserve(entry.target);
    });
  }, {threshold: 1});

  document.querySelectorAll('input.format--phone').forEach(el => {
    observer.observe(el);
  });
} else {
  setupPhoneFields();
}

// export globally for checkout
window.epos.setupPhoneFields = setupPhoneFields;
